/**
 * CodeInventoryView Component
 *
 * View wrapper for Code Inventory Report.
 * Shows comprehensive file and program listing.
 */

import { useState, useEffect } from 'react'
import { ArrowLeft, Loader2, AlertCircle, FileCode } from 'lucide-react'
import { CodeInventoryReport } from '../reports'
import { getJsonArtifact } from '../../services/codeAnalysisService'
import './SharedReportView.css'

function CodeInventoryView({ onBack, analysisContext }) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [comprehensiveData, setComprehensiveData] = useState(null)

  const jobContext = analysisContext

  // Fetch comprehensive data
  useEffect(() => {
    const fetchData = async () => {
      if (!jobContext?.jobs?.codeanalysis_job_id) {
        setError('No code analysis job found')
        setLoading(false)
        return
      }

      setLoading(true)
      setError(null)

      try {
        const data = await getJsonArtifact(
          jobContext.jobs.codeanalysis_job_id,
          'comprehensive_parse_results.json'
        )
        setComprehensiveData(data)
      } catch (err) {
        console.error('Failed to fetch code inventory data:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [jobContext])

  return (
    <div className="report-view">
      {/* Header */}
      <div className="report-header">
        <button onClick={onBack} className="back-btn">
          <ArrowLeft size={20} />
          Back to Reports
        </button>
        <div className="header-title">
          <FileCode size={24} />
          <h1>Code Inventory</h1>
        </div>
      </div>

      {/* Content */}
      <div className="report-content">
        {loading ? (
          <div className="loading-state">
            <Loader2 size={32} className="spin" />
            <p>Loading code inventory...</p>
          </div>
        ) : error ? (
          <div className="error-state">
            <AlertCircle size={32} />
            <p>{error}</p>
            <button onClick={onBack} className="secondary-btn">
              Go Back
            </button>
          </div>
        ) : (
          <CodeInventoryReport
            comprehensiveData={comprehensiveData}
            title="Code Inventory Report"
          />
        )}
      </div>
    </div>
  )
}

export default CodeInventoryView
